import {
  useDaily,
  useLocalSessionId,
  useVideoTrack
} from '@daily-co/daily-react';
import { useCallback } from 'react';

import useMuteState from '../../hooks/useMuteState';
import {
  CameraOff,
  CameraOn,
  Leave,
  MicrophoneOff,
  MicrophoneOn
} from './Icons';
import './Tray.css';

export default function Tray({ leaveCall }) {
  const callObject = useDaily();

  const localSessionId = useLocalSessionId();
  const localVideo = useVideoTrack(localSessionId);
  const mutedVideo = localVideo.isOff;

  // Usando o hook de mute
  const {
    isMuted: mutedAudio,
    toggleMute: toggleAudio,
    muteReason,
    canToggleMute
  } = useMuteState();

  const toggleVideo = useCallback(() => {
    callObject.setLocalVideo(mutedVideo);
  }, [callObject, mutedVideo]);

  return (
    <div className="tray">
      <div className="tray-buttons-container">
        <div className="controls">
          <button onClick={toggleVideo} type="button">
            {mutedVideo ? <CameraOff /> : <CameraOn />}
          </button>
          <button
            onClick={toggleAudio}
            type="button"
            disabled={!canToggleMute}
            className={muteReason === 'TURN_STATE' ? 'muted-by-system' : ''}
            title={muteReason === 'TURN_STATE' ? 'Mutado pelo sistema' : ''}
          >
            {mutedAudio ? <MicrophoneOff /> : <MicrophoneOn />}
          </button>
        </div>
        <div className="leave">
          <button onClick={leaveCall} type="button">
            <Leave />
          </button>
        </div>
      </div>
    </div>
  );
}
